<!-- <h2>Payment Done Not Update List</h2>
<table>
    <thead>
        <th>Ticket Id</th>
        <th>ITI Code</th>
        <th>Rollno</th>
        <th>Name</th>
        <th>Mobile No</th>
        <th>CCREF Nno</th>
        <th>Trade</th>
        <th>Action</th>
    </thead>
    <tbody>
        <tr *ngFor="let item of pduTable let i=index">
            <td>{{item.ticketId}}</td>
            <td>{{item.iticode}}</td>
            <td>{{item.singlerollno}}</td>
            <td>{{item.name}}</td>
            <td>{{item.mobileno}}</td>
            <td>{{item.ccrefno}}</td>
            <td>{{item.trade}}</td>

            <td>
                <button class="btn btn-success" (click)="editPdu(i)">Action</button>
            </td>
        </tr>
    </tbody>
</table>

<hr>

<h2>Payment Done Not Update Pending List</h2>
<table>
    <thead>
        <th>Ticket Id</th>
        <th>ITI Code</th>
        <th>Rollno</th>
        <th>Name</th>
        <th>Mobile No</th>
        <th>CCREF Nno</th>
        <th>Trade</th>
        <th>Status</th>
        <th>Action</th>
    </thead>
    <tbody>
        <tr *ngFor="let item of pduPendingListTable let i=index">
            <td>{{item.ticketId}}</td>
            <td>{{item.iticode}}</td>
            <td>{{item.singlerollno}}</td>
            <td>{{item.name}}</td>
            <td>{{item.mobileno}}</td>
            <td>{{item.ccrefno}}</td>
            <td>{{item.trade}}</td>
            <td>{{item.admin_status}}</td>
            <td>
                <button class="btn btn-success" (click)="editPduiPending(i)">Action</button>
            </td>
        </tr>
    </tbody>
</table>

<hr>

<h2>Payment Done Not Update Resolved and Rejected List</h2>
<table>
    <thead>
        <th>Ticket Id</th>
        <th>ITI Code</th>
        <th>Rollno</th>
        <th>Name</th>
        <th>Mobile No</th>
        <th>CCREF Nno</th>
        <th>Trade</th>
        <th>Status</th>
        <th>Action</th>
    </thead>
    <tbody>
        <tr *ngFor="let item of pduRes_RejListTable let i=index">
            <td>{{item.ticketId}}</td>
            <td>{{item.iticode}}</td>
            <td>{{item.singlerollno}}</td>
            <td>{{item.name}}</td>
            <td>{{item.mobileno}}</td>
            <td>{{item.ccrefno}}</td>
            <td>{{item.trade}}</td>
            <td>{{item.admin_status}}</td>
            <td>
                <button class="btn btn-success" (click)="editPduRes_Rej(i)">View</button>
            </td>
        </tr>
    </tbody>
</table>

<hr> -->
<h2>Payment Related Issue List</h2>

<mat-form-field>
    <input matInput (keyup)="applyFilter($event)" placeholder="Filter">
</mat-form-field>

<div class="example-container mat-elevation-z8">
    <mat-table #table [dataSource]="dataSource" matSort>

        <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->

        <!-- Position Column -->
        <ng-container matColumnDef="ticketId">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Ticket Id </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.ticketId}} </mat-cell>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="iticode">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Exam Center Code </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.iticode}} </mat-cell>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="singlerollno">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Single Roll No
            </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.singlerollno}} </mat-cell>
        </ng-container>


        <!-- Weight Column -->
        <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.name}} </mat-cell>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="mobileno">
            <mat-header-cell *matHeaderCellDef mat-sort-header> mobile no </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.mobileno}} </mat-cell>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="ccrefno">
            <mat-header-cell *matHeaderCellDef mat-sort-header> cc refno </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.ccrefno}} </mat-cell>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="ccrefnostatus">
            <mat-header-cell *matHeaderCellDef mat-sort-header> cc refno status </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.ccrefnostatus}} </mat-cell>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="entrydate">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Grievance Date </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.entrydate}} </mat-cell>
        </ng-container>

        <!-- Name Column -->
        <!-- <ng-container matColumnDef="trade">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Trade </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.trade}} </mat-cell>
        </ng-container> -->

        <!-- Symbol Column -->
        <ng-container matColumnDef="action">
            <mat-header-cell *matHeaderCellDef mat-sort-header> View </mat-header-cell>
            <mat-cell *matCellDef="let row"> <button class="btn btn-success"
                    (click)="selected_family_member.select(row)" (click)="report()">View</button>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="submit">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Submit </mat-header-cell>
            <mat-cell *matCellDef="let row"> <button class="btn btn-success"
                    (click)="selected_family_member.select(row)" (click)="report_submit()">Submit</button>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    </mat-table>
    <mat-paginator #t1Paginator="matPaginator" length='500' [pageSizeOptions]="[ 5,10, 25, 50, 100, 500]"></mat-paginator>


</div>

<!-- <hr>

<h2>Payment Related Issue Resolved and Rejected List</h2>

<mat-form-field>
    <input matInput (keyup)="applyFilterView($event)" placeholder="Filter">
</mat-form-field>

<button mat-raised-button color="primary" (click)="ExportTOExcel()">Export as Excel</button>



<div class="example-container mat-elevation-z8" #TSTSS>
    <mat-table  [dataSource]="dataSource_view" #t1Sort="matSort" matSort>


        <ng-container matColumnDef="ticketId">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Ticket Id </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.ticketId}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="iticode">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Exam Center Code </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.iticode}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="singlerollno">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Single Roll No </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.singlerollno}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Candidate Name </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.name}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="mobileno">
            <mat-header-cell *matHeaderCellDef mat-sort-header> mobileno </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.mobileno}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="ccrefno">
            <mat-header-cell *matHeaderCellDef mat-sort-header> cc refno </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.ccrefno}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="ccrefnostatus">
            <mat-header-cell *matHeaderCellDef mat-sort-header> cc refno status </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.ccrefnostatus}} </mat-cell>
        </ng-container>

                <ng-container matColumnDef="entrydate">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Grievance Date </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.entrydate}} </mat-cell>
                </ng-container>
        


        <ng-container matColumnDef="admin_status">
            <mat-header-cell *matHeaderCellDef mat-sort-header> status
            </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.admin_status}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="action">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Action </mat-header-cell>
            <mat-cell *matCellDef="let row"> <button class="btn btn-success" (click)="selected_view.select(row)"
                    (click)="report_view()">View</button>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns_view"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns_view;"></mat-row>

    </mat-table>
    <mat-paginator #t1Paginator="matPaginator" [pageSizeOptions]="[3, 10, 25, 100]"></mat-paginator>


</div> -->